import { render, staticRenderFns } from "./PlanejamentoOrdemDeServicoPilha.vue?vue&type=template&id=22d09e3a&scoped=true"
import script from "./PlanejamentoOrdemDeServicoPilha.vue?vue&type=script&lang=js"
export * from "./PlanejamentoOrdemDeServicoPilha.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoOrdemDeServicoPilha.vue?vue&type=style&index=0&id=22d09e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d09e3a",
  null
  
)

export default component.exports